// eslint-disable-next-line
import { Sticky, ScrollEvent } from './Sticky.es6';

const StickyPlugin = {
	install(Vue) {
		/* eslint no-param-reassign: [2, { "props": true, "ignorePropertyModificationsFor": ['vnode', 'cssobj'] }] */
		/* eslint max-len: [2, { "code": 1025, "ignoreComments": true, "tabWidth": 4 }] */
		/* eslint no-underscore-dangle: [2, {
		"allow": [
			"_unstickTransitionTO1",
			"_unstickTransitionTO2",
			"_setFloor",
			"_setCeiling",
			"_stickElement"]
		}] */

		// 2. add a global asset
		Vue.directive('sticky', {
			bind(el, binding, vnode) {
				const options = Object.assign({}, binding.value);

				if (typeof options.element !== 'undefined') {
					options.element = vnode.context.$el.querySelector(options.element);
				} else {
					options.element = el;
				}

				let isLeaderBoard = false;

				if ((options.element.classList.contains('ad-101') && options.element.dataset.pos === '101')
					||					(options.element.classList.contains('ad-2025') && options.element.dataset.pos === '2025')
				) {
					isLeaderBoard = true;
				}

				if (isLeaderBoard && window && window.webmd && window.webmd.isUnStickyDFPServed) {
					return false;
				}

				ScrollEvent.startScrollEvent();

				// some logic ...
				const stick = new Sticky(options, vnode.context);

				vnode.context[`${options.name}`] = stick;

				if (isLeaderBoard && window && window.webmd) {
					window.webmd.leaderboardStickyPlugin = stick;
				}
			},
		});

		// 3. inject some component options
		Vue.mixin({
			methods: {
				sticky(options) {
					let isLeaderBoard = false;

					const $el = (typeof options.element === 'string') ? document.querySelector(options.element) : options.element;

					if (($el.classList.contains('ad-101') && $el.dataset.pos === '101')
						||						($el.classList.contains('ad-2025') && $el.dataset.pos === '2025')
					) {
						isLeaderBoard = true;
					}

					if (isLeaderBoard && window && window.webmd && window.webmd.isUnStickyDFPServed) {
						return false;
					}

					ScrollEvent.startScrollEvent();

					const stick = new Sticky(options, this);

					this[options.name] = stick;

					if (isLeaderBoard && window && window.webmd) {
						window.webmd.leaderboardStickyPlugin = stick;
					}

					return this[options.name];
				},
			},
		});
	},
};

export default StickyPlugin;
